"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconMedal2 = function SvgIconMedal2(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "medal 2 icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Medal 2 Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.998 17.25c6.835 0 12.376 5.54 12.376 12.375S30.833 42 23.998 42c-6.834 0-12.375-5.54-12.375-12.375 0-6.834 5.54-12.375 12.375-12.375zm.027 5.25c-2.466 0-4.359 1.198-5.412 3.074l-.113.211 2.93 1.382c.355-1.027 1.27-1.867 2.52-1.867 1.046 0 1.569.467 1.569 1.232 0 .952-1.176 1.512-2.688 2.315-1.807.975-3.875 2.23-4.007 4.763l-.007.258v2.445h9.819v-3.042h-6.384c.187-1.046 1.475-1.699 2.875-2.446 1.754-.933 3.621-2.016 3.621-4.274 0-2.315-1.68-4.051-4.723-4.051zM14.941 6c.79 0 1.523.415 1.93 1.093l4.86 8.103a14.555 14.555 0 00-7.704 3.754L6.204 7.77A1.125 1.125 0 017.124 6zm25.933 0a1.125 1.125 0 01.92 1.77L33.97 18.947a14.555 14.555 0 00-7.704-3.754l4.86-8.1A2.25 2.25 0 0133.057 6z"
  }));
};

var _default = SvgIconMedal2;
exports.default = _default;